import React from "react";

export interface SectionTitleProps {
  tagline?:string;
  align?:'left'|'center'|'right'
}
export const SectionTitle =  ({tagline, children, className, align = 'center', ...props}: SectionTitleProps & React.HTMLAttributes<HTMLDivElement>) => {
  const alignClasses = { 'center': 'txt-center', 'left': 'txt-left', 'right': 'txt-right'}
  return <h2 className={className ?  alignClasses[align] + " " + className : alignClasses[align] } {...props}>
            {tagline && <small className={"tagline"}>{tagline}</small>}
            {children}
        </h2>
}
